import React from 'react';
import styled from 'styled-components';

import { OrganizationSettingsForm } from '../components';
import { useOrganizations } from '../providers';

const SettingsContainer = styled.div`
  margin: 24px;
  width: 50%;
`;

const Settings = () => {
  const { currentOrganization, updateOrganization } = useOrganizations();

  return (
    <SettingsContainer>
      <OrganizationSettingsForm
        currentOrganization={currentOrganization}
        onSubmit={(data) => updateOrganization(currentOrganization.id, data)}
      />
    </SettingsContainer>
  );
};

export { Settings };
